import { render } from "./tkiatop.vue?vue&type=template&id=1de3030a&scoped=true"
import script from "./tkiatop.vue?vue&type=script&lang=js"
export * from "./tkiatop.vue?vue&type=script&lang=js"

import "./tkiatop.vue?vue&type=style&index=0&id=1de3030a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1de3030a"

export default script